import { isValidPhoneNumber } from 'react-phone-number-input';

/** Practical email check (not full RFC). */
export function isValidEmail(value) {
  const s = String(value).trim();
  if (s.length < 5 || s.length > 254) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(s);
}

export function normalizeEmail(value) {
  return String(value).trim().toLowerCase();
}

/** Full number with country code (E.164 from the phone input). */
export function isValidPhone(value) {
  if (value == null || String(value).trim() === '') return false;
  return isValidPhoneNumber(String(value).trim());
}

export function isNonEmptyName(value) {
  const s = String(value).trim();
  return s.length >= 2 && s.length <= 200;
}
